import { Grid } from "@mui/material"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import { useEffect, useState } from "react"

// Webservices
import * as packageService from "services/packages/package.service"

function Revenue() {
  const [lazajellaRevenues, setLazajellaRevenues] = useState({})
  const [alamanaRevenues, setAlamanaRevenues] = useState({})
  const [mylerzRevenues, setMylerzRevenues] = useState({})

  // Calculate all revenues for each company
  const calculateRevnues = async () => {
    try {
      const {
        data: { lazajella, alamana, mylerz },
      } = await packageService.getRevenues()
      setLazajellaRevenues({ ...lazajella })
      setAlamanaRevenues({ ...alamana })
      setMylerzRevenues({ ...mylerz })
      return { lazajella, alamana, mylerz } || {}
    } catch (error) {
      return error
    }
  }

  useEffect(() => {
    calculateRevnues()
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar absolute />
      <MDBox mt={8}>
        <MDBox mb={4}>
          <MDTypography>Alamana</MDTypography>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={8} md={4} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="leaderboard"
                title={`${alamanaRevenues.all?.count} colis terminé`}
                subject={"Total des colis"}
                count={(alamanaRevenues.all?.total || 0).toFixed(2)}
                percentage={{
                  color: "info",
                  amount: "TND",
                  label: "Monnaie du dinar tunisien",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={8} md={4} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="leaderboard"
                title={`${alamanaRevenues.completed?.count} colis terminé`}
                subject={"Colis Payé"}
                count={(alamanaRevenues.completed?.total || 0).toFixed(2)}
                percentage={{
                  color: "info",
                  amount: "TND",
                  label: "Monnaie du dinar tunisien",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={8} md={4} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="leaderboard"
                title={`${alamanaRevenues.missing?.count} colis manquant`}
                subject={"Colis Manquants"}
                count={(alamanaRevenues.missing?.total || 0).toFixed(2)}
                percentage={{
                  color: "info",
                  amount: "TND",
                  label: "Monnaie du dinar tunisien",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mb={4} mt={4}>
          <MDTypography>Lazajella</MDTypography>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={8} md={4} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="leaderboard"
                title={`${lazajellaRevenues.all?.count} colis terminé`}
                subject={"Total des colis"}
                count={(lazajellaRevenues.all?.total || 0).toFixed(2)}
                percentage={{
                  color: "info",
                  amount: "TND",
                  label: "Monnaie du dinar tunisien",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={8} md={4} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="leaderboard"
                title={`${lazajellaRevenues.completed?.count} colis terminé`}
                subject={"Colis Payé"}
                count={(lazajellaRevenues.completed?.total || 0).toFixed(2)}
                percentage={{
                  color: "info",
                  amount: "TND",
                  label: "Monnaie du dinar tunisien",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={8} md={4} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="leaderboard"
                title={`${lazajellaRevenues.missing?.count} colis manquant`}
                subject={"Colis Manquants"}
                count={(lazajellaRevenues.missing?.total || 0).toFixed(2)}
                percentage={{
                  color: "info",
                  amount: "TND",
                  label: "Monnaie du dinar tunisien",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mb={4} mt={4}>
          <MDTypography>Mylerz</MDTypography>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={8} md={4} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="leaderboard"
                title={`${mylerzRevenues.all?.count} colis total`}
                subject={"Total des colis"}
                count={(mylerzRevenues.all?.total|| 0).toFixed(2)}
                percentage={{
                  color: "info",
                  amount: "TND",
                  label: "Monnaie du dinar tunisien",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={8} md={4} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="leaderboard"
                title={`${mylerzRevenues.completed?.count} colis payé`}
                subject={"Colis Payé"}
                count={(mylerzRevenues.completed?.total || 0).toFixed(2)}
                percentage={{
                  color: "info",
                  amount: "TND",
                  label: "Monnaie du dinar tunisien",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={8} md={4} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="leaderboard"
                title={`${mylerzRevenues.missing?.count} colis manquants`}
                subject={"Colis Manquants"}
                count={(mylerzRevenues.missing?.total || 0).toFixed(2)}
                percentage={{
                  color: "info",
                  amount: "TND",
                  label: "Monnaie du dinar tunisien",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  )
}

export default Revenue
